import BundleTargeting from './bundle-targeting';

export default BundleTargeting;
